import React, {Fragment} from 'react';
import {Document} from 'components';
import {HeroSW, HeroYuval, Story, Values} from '.';
import {Outro} from '../common';
import {config} from 'helpers';

export function About(props) {
  return (
    <Fragment>
      <Document.Title>About</Document.Title>
      {config.sw
        ? <>
          <HeroSW {...props} />
          <HeroYuval />
        </>
        : <HeroYuval {...props} />
      }
      <Story />
      <Values />
      <Outro />
    </Fragment>
  );
}
